import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "o-mainHeader__quicksearch" }
const _hoisted_2 = ["action"]
const _hoisted_3 = ["name", "aria-label", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "o-mainHeader__quicksearchTrigger",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSearch()))
    }, [
      _createVNode(_component_IconComponent, {
        "icon-id": _ctx.IconName.Search
      }, null, 8, ["icon-id"])
    ]),
    _createElementVNode("form", {
      class: _normalizeClass(['o-mainHeader__quicksearchForm', {'is-active': _ctx.isActive}]),
      action: _ctx.searchUrl,
      method: "get",
      ref: "searchForm"
    }, [
      _createElementVNode("input", {
        class: "o-mainHeader__quicksearchInput",
        type: "text",
        autocomplete: "off",
        name: _ctx.searchParam,
        "aria-label": _ctx.quickSearchLabel,
        value: _ctx.searchString,
        ref: "searchInput",
        placeholder: "",
        onInput: _cache[1] || (_cache[1] = e => { _ctx.searchString = e.target.value; _ctx.searchInputChange(); })
      }, null, 40, _hoisted_3)
    ], 10, _hoisted_2)
  ]))
}